module.exports = __webpack_public_path__ + "img/1481301183.0b6fd180.jpg";